import Images from "../assets/assets";
import { StaticImageData } from "next/image";

export interface TeamMember {
  id: number;
  name: string;
  position: string;
  quote?: string;
  description?: string;
  image: StaticImageData | string;
  linkedIn?: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "Manish Jain",
    position: "Co-founder, Managing director",
    quote: "“Don't dream about success, Work for it”",
    description: "Manish is the co-founder and business development leader of Konstant Infosolutions. As the Managing Director, Manish is an asset to our company as he leads us to develop initiatives. For thirteen years, he has steered Konstant from modest origins to one of the most vibrant, successful software development companies in the world.",
    image: Images?.team1,
    linkedIn: "#",
  },
  {
    id: 2,
    name: "Vipin Jain",
    position: "Co-founder, CEO",
    quote:
      "“It's not about how you do it, it's about how well you accomplish it!”",
    description:
      "Vipin Jain is the CEO of Konstant, which he co-founded in 2003. Having the genes of marketing, project management, internal administration, research and development, he is responsible for leading Konstant’s burgeoning strategy discipline and sharpening the overall strategic vision and approach of the agency.",
    image: Images?.team2,
    linkedIn: "#",
  },
  {
    id: 3,
    name: "Yogendra Gupta",
    position: "Tech Lead, Mobile, Cloud",
    quote:
      '"Quality transcends quantity, one home run is better than two doubles"',
    description:
      "Yogendra heads the hybrid app development team at Konstant with over eleven years of extensive experience in developing and managing online servers and performing problem analysis. He provides leadership guidance to the technical team and ensures resourceful and qualitative results.",
    image: Images?.team3,
    linkedIn: "#",
  },
  {
    id: 4,
    name: "DD Agarwal",
    position: "Tech Lead, Web, Open-source",
    quote: '"Find a way to do it better- only good won’t leave an impression"',
    description:
      "DD is a PMP Certified Project Manager responsible for the full project development lifecycle leading the team for user experience, digital product design, and developing commercial websites. More than a decade experience in web development, he has a strong analytical and problem solving acumen.",
    image: Images?.team4,
    linkedIn: "#",
  },
];
